var _defs, _defs2, _defs3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcons8Skincare100(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100px",
    height: "100px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "skin",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f35b35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#cdf335"
  })))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "turban",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ba3aff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ff3a7f"
  })))), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "turban-bottom",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "60%",
    stopColor: "#ba3aff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ff3a7f"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.932
    },
    fill: "url(#turban-bottom)",
    d: "M 68.5,17.5 C 66.2543,16.5448 63.921,15.8782 61.5,15.5C 57.9279,11.1232 53.2613,9.45657 47.5,10.5C 41.6744,9.99991 36.3411,11.3332 31.5,14.5C 34.0933,5.58714 40.0933,1.25381 49.5,1.5C 60.1076,1.77533 66.441,7.10866 68.5,17.5 Z"
  })), "\nt", /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.99
    },
    fill: "url(#turban)",
    d: "M 61.5,15.5 C 62.6005,16.6049 63.2671,17.9382 63.5,19.5C 57.537,20.8298 51.2037,21.4964 44.5,21.5C 37.7963,21.4964 31.463,20.8298 25.5,19.5C 26.8908,17.1097 28.8908,15.4431 31.5,14.5C 36.3411,11.3332 41.6744,9.99991 47.5,10.5C 53.2613,9.45657 57.9279,11.1232 61.5,15.5 Z"
  })), "\nt", /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.989
    },
    fill: "url(#turban)",
    d: "M 25.5,19.5 C 31.463,20.8298 37.7963,21.4964 44.5,21.5C 51.2037,21.4964 57.537,20.8298 63.5,19.5C 64.9562,24.343 64.6229,29.1764 62.5,34C 55.3333,34.1667 48.1667,34.3333 41,34.5C 33.2654,34.4656 25.7654,33.799 18.5,32.5C 19.5491,27.3973 21.8824,23.064 25.5,19.5 Z"
  })), "\nt", /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.986
    },
    fill: "url(#turban-bottom)",
    d: "M 61.5,15.5 C 63.921,15.8782 66.2543,16.5448 68.5,17.5C 77.2647,23.56 81.5981,32.06 81.5,43C 81.23,47.2424 80.5633,51.409 79.5,55.5C 78.2101,56.0577 77.3768,57.0577 77,58.5C 75.4758,53.1185 73.1425,48.1185 70,43.5C 66.6754,39.9024 62.8421,38.2357 58.5,38.5C 57.8333,38.8333 57.1667,39.1667 56.5,39.5C 51.0109,41.1188 45.3442,41.9521 39.5,42C 37.5087,42.3736 35.842,43.207 34.5,44.5C 27.8205,46.8195 23.6538,51.4861 22,58.5C 21.6232,57.0577 20.7899,56.0577 19.5,55.5C 17.5054,47.8939 17.1721,40.2272 18.5,32.5C 25.7654,33.799 33.2654,34.4656 41,34.5C 48.1667,34.3333 55.3333,34.1667 62.5,34C 64.6229,29.1764 64.9562,24.343 63.5,19.5C 63.2671,17.9382 62.6005,16.6049 61.5,15.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "url(#skin)",
    d: "M 58.5,38.5 C 74.4117,51.1355 74.4117,63.8022 58.5,76.5C 55.9274,78.1317 55.2608,80.2984 56.5,83C 53.0296,85.8877 52.6962,89.0544 55.5,92.5C 51.5,93.8333 47.5,93.8333 43.5,92.5C 46.3038,89.0544 45.9704,85.8877 42.5,83C 43.772,80.9555 43.4386,79.1222 41.5,77.5C 39.9579,76.2532 38.4579,76.2532 37,77.5C 35.53,75.8481 33.6967,74.8481 31.5,74.5C 29.0983,76.049 26.4317,76.7157 23.5,76.5C 22.8985,73.5963 21.0652,71.9297 18,71.5C 15.6714,66.9013 15.3381,62.2346 17,57.5C 17.7083,56.6195 18.5416,55.9528 19.5,55.5C 20.7899,56.0577 21.6232,57.0577 22,58.5C 23.6538,51.4861 27.8205,46.8195 34.5,44.5C 35.2389,44.369 35.9056,44.5357 36.5,45C 29.0548,57.5434 31.7215,67.2101 44.5,74C 54.7434,75.7964 61.9101,71.963 66,62.5C 68.1752,52.5051 65.0085,44.8384 56.5,39.5C 57.1667,39.1667 57.8333,38.8333 58.5,38.5 Z M 79.5,55.5 C 81.9596,56.9095 83.2929,59.0762 83.5,62C 83.0447,65.2812 82.2113,68.4478 81,71.5C 77.9348,71.9297 76.1015,73.5963 75.5,76.5C 72.4228,76.6529 69.5895,75.9863 67,74.5C 64.849,74.6431 63.1824,75.6431 62,77.5C 60.9887,76.6634 59.8221,76.33 58.5,76.5C 74.4117,63.8022 74.4117,51.1355 58.5,38.5C 62.8421,38.2357 66.6754,39.9024 70,43.5C 73.1425,48.1185 75.4758,53.1185 77,58.5C 77.3768,57.0577 78.2101,56.0577 79.5,55.5 Z M 56.5,39.5 C 65.0085,44.8384 68.1752,52.5051 66,62.5C 61.9101,71.963 54.7434,75.7964 44.5,74C 31.7215,67.2101 29.0548,57.5434 36.5,45C 35.9056,44.5357 35.2389,44.369 34.5,44.5C 35.842,43.207 37.5087,42.3736 39.5,42C 45.3442,41.9521 51.0109,41.1188 56.5,39.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dfe2e3",
    d: "M 43.5,92.5 C 41.4402,93.8112 39.2735,93.8112 37,92.5C 34.0393,95.6163 30.5393,96.2829 26.5,94.5C 24.9848,92.4527 24.1515,90.1193 24,87.5C 18.2352,84.053 18.0686,80.3863 23.5,76.5C 26.4317,76.7157 29.0983,76.049 31.5,74.5C 33.6967,74.8481 35.53,75.8481 37,77.5C 38.4579,76.2532 39.9579,76.2532 41.5,77.5C 43.4386,79.1222 43.772,80.9555 42.5,83C 45.9704,85.8877 46.3038,89.0544 43.5,92.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dfe1e2",
    d: "M 75.5,76.5 C 80.9314,80.3863 80.7648,84.053 75,87.5C 74.8062,94.5197 71.3062,97.0197 64.5,95C 63.6667,94.1667 62.8333,93.3333 62,92.5C 59.7265,93.8112 57.5598,93.8112 55.5,92.5C 52.6962,89.0544 53.0296,85.8877 56.5,83C 55.2608,80.2984 55.9274,78.1317 58.5,76.5C 59.8221,76.33 60.9887,76.6634 62,77.5C 63.1824,75.6431 64.849,74.6431 67,74.5C 69.5895,75.9863 72.4228,76.6529 75.5,76.5 Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Skincare100);
export default __webpack_public_path__ + "static/media/icons8-skincare-100.9bac1d923bfe909d1e2bdc4130d1ecf7.svg";
export { ForwardRef as ReactComponent };